import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TransactionInfoService} from "../../../services/transaction-info.service";
import {ClaimTypes} from "../../../model/claim-type.model";

@Component({
    selector: 'app-clinical-expenses',
    templateUrl: './clinical-expenses.component.html',
    styleUrls: ['./clinical-expenses.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClinicalExpensesComponent implements OnInit {

    constructor( private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_CLINICAL]);
    }

  ngOnInit() {
  }

}
